import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import { useState } from "react";
import ReactDatePicker from "react-datepicker";
import { getEmployeesComissions } from "../../../services/UserService";
import dayjs from "dayjs";
import currencyBRFormat from "../../../util/CurrencyUtils";
import { CDBTable, CDBTableBody, CDBTableHeader } from "cdbreact";

const RelatorioComissoesModal = (props) => {
  const [isOpen, setIsOpen] = useState(true);
  const toggle = () => {
    props.setRelatorioComissionOpen(false);
  };
  const date = new Date();
  const defaultStartDate = new Date(date.getFullYear(), date.getMonth(), 1);
  const [startDate, setStartDate] = useState(defaultStartDate);
  const [endDate, setEndDate] = useState(date);
  const [employeesComissions, setEmployeesComissions] = useState();
  const [totalComissions, setTotalComissions] = useState();

  function listEmployeeComissions() {
    getEmployeesComissions(
      dayjs(startDate).format("YYYY-MM-DD"),
      dayjs(endDate).format("YYYY-MM-DD")
    ).then((response) => {
      setEmployeesComissions(response.data);
      setTotalComissions(response.totalComissions);
    });
  }

  return (
    <div>
      <Modal isOpen={isOpen} toggle={toggle} backdrop="static" size="lg" centered>
        {/* Header limpo sem bordas e com título em destaque */}
        <ModalHeader toggle={toggle} className="border-0 pb-0">
          <span className="fw-bold">Relatório de Comissões</span>
        </ModalHeader>

        <ModalBody className="pt-3">
          {/* Seção de Filtros */}
          <div className="row align-items-end g-3 mb-4">
            <div className="col-md-4 col-sm-6">
              <label className="small fw-bold text-muted mb-2 d-block">Início</label>
              <ReactDatePicker
                className="form-control"
                dateFormat="dd/MM/yyyy"
                maxDate={new Date()}
                locale="pt-BR"
                selected={startDate}
                todayButton="Hoje"
                onMonthChange={(date) => setStartDate(date)}
                onChange={(date) => setStartDate(date)}
              />
            </div>

            <div className="col-md-4 col-sm-6">
              <label className="small fw-bold text-muted mb-2 d-block">Fim</label>
              <ReactDatePicker
                className="form-control"
                dateFormat="dd/MM/yyyy"
                maxDate={new Date()}
                locale="pt-BR"
                selected={endDate}
                todayButton="Hoje"
                onMonthChange={(date) => setEndDate(date)}
                onChange={(date) => setEndDate(date)}
              />
            </div>

            <div className="col-md-4 col-12">
              <button 
                onClick={listEmployeeComissions} 
                className="btn btn-primary w-100 d-flex align-items-center justify-content-center"
                style={{ height: '38px' }}
              >
                <i className="fa-solid fa-magnifying-glass me-2"></i>
                Gerar Relatório
              </button>
            </div>
          </div>

          {/* Resultados */}
          {employeesComissions && (
            <div className="mt-2 border-top pt-3">
              <CDBTable className="alcon-table" responsiveSm borderless>
                <CDBTableHeader>
                  <tr>
                    <th>Funcionário</th>
                    <th className="text-end px-4">Comissão Total</th>
                  </tr>
                </CDBTableHeader>
                <CDBTableBody>
                  {employeesComissions.map((ec) => (
                    <tr key={ec.id}>
                      {/* Avatar com a inicial + Nome com o padrão Alcon Auto */}
                      <td className="fw-bold text-dark">
                        <div className="d-flex align-items-center">
                          <div 
                            className="bg-primary-subtle text-primary rounded-circle d-flex align-items-center justify-content-center me-2" 
                            style={{ width: '32px', height: '32px', fontSize: '0.8rem' }}
                          >
                            {ec.employeeName.charAt(0).toUpperCase()}
                          </div>
                          {ec.employeeName}
                        </div>
                      </td>
                      {/* Comissão alinhada à direita e destacada em verde */}
                      <td className="text-end px-4 align-middle fw-bold text-success">
                        {currencyBRFormat(ec.employeeTotalComission)}
                      </td>
                    </tr>
                  ))}

                  {/* Linha de Totalização destacada em cinza claro */}
                  <tr className="table-light border-top" style={{ borderTopWidth: '2px' }}>
                    <td className="fw-bold text-dark px-3 py-3">Total Geral</td>
                    <td className="text-end px-4 py-3 align-middle fw-bold text-success" style={{ fontSize: '1.05rem' }}>
                      {currencyBRFormat(totalComissions)}
                    </td>
                  </tr>
                </CDBTableBody>
              </CDBTable>
            </div>
          )}
        </ModalBody>

         <ModalFooter className="border-0 pt-0">
          <button type="button" onClick={toggle} className="btn btn-outline-secondary w-100 w-sm-auto">
            Fechar
          </button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default RelatorioComissoesModal;